/**
 * Double Tap To Go - Vanilla JavaScript
 * Prevents first tap on dropdown menus for mobile devices
 */
class DoubleTapToGo {
  constructor(element, options = {}) {
    this.element = element;
    this.settings = {
      automatic: true,
      selectorClass: "doubletap",
      selectorChain: "li:has(ul)",
      ...options,
    };

    this.preventClick = false;
    this.currentTap = null;

    this.init();
  }

  init() {
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.element.addEventListener("touchstart", this.handleTouchStart, {
      passive: true,
    });
    this.element.addEventListener("click", this.handleClick);

    this.addSelectors();
  }

  // Add doubletap class to dropdown items
  addSelectors() {
    if (!this.settings.automatic) {
      return;
    }

    const items = this.element.querySelectorAll("li");
    items.forEach((li) => {
      if (li.querySelector("ul")) {
        li.classList.add(this.settings.selectorClass);
      }
    });
  }

  handleClick(event) {
    if (this.preventClick) {
      event.preventDefault();
    } else {
      this.currentTap = null;
    }
  }

  // Track touch events for double tap logic
  handleTouchStart(event) {
    const target = event.target.closest("li");

    if (!target || !target.classList.contains(this.settings.selectorClass)) {
      this.preventClick = false;
      return;
    }

    if (target === this.currentTap) {
      this.preventClick = false;
      return;
    }

    this.preventClick = true;
    this.currentTap = target;
    event.stopPropagation();
  }

  reset() {
    this.currentTap = null;
  }

  destroy() {
    this.element.removeEventListener("touchstart", this.handleTouchStart);
    this.element.removeEventListener("click", this.handleClick);
    this.currentTap = null;
  }
}

function doubleTapToGo(selector, options) {
  const elements =
    typeof selector === "string"
      ? document.querySelectorAll(selector)
      : [selector];

  const instances = [];

  elements.forEach((element) => {
    if (element && !element._doubleTapToGoInstance) {
      const instance = new DoubleTapToGo(element, options);
      element._doubleTapToGoInstance = instance;
      instances.push(instance);
    }
  });

  return instances.length === 1 ? instances[0] : instances;
}

export { doubleTapToGo };
export default DoubleTapToGo;
